const GENIUS_SCHOOL_DETAILS_SESSION_KEY = "genius_school_details_session";
let configuredStorage = null;
let memoryFallback = null;
function getSessionStorageAdapter() {
    if (typeof sessionStorage === "undefined")
        return null;
    return {
        getItem: (key) => sessionStorage.getItem(key),
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: (key) => sessionStorage.removeItem(key),
    };
}
function getMemoryStorageAdapter() {
    return {
        getItem: () => memoryFallback,
        setItem: (_key, value) => {
            memoryFallback = value;
        },
        removeItem: () => {
            memoryFallback = null;
        },
    };
}
function resolveStorage() {
    return (configuredStorage ?? getSessionStorageAdapter() ?? getMemoryStorageAdapter());
}
/** Optional: register app storage (e.g. MMKV on mobile). Web uses sessionStorage by default. */
export function configureGeniusSchoolDetailsStorage(storage) {
    configuredStorage = storage;
}
function readSessionRaw() {
    try {
        const raw = resolveStorage().getItem(GENIUS_SCHOOL_DETAILS_SESSION_KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
function writeSession(session) {
    try {
        resolveStorage().setItem(GENIUS_SCHOOL_DETAILS_SESSION_KEY, JSON.stringify(session));
    }
    catch {
        // ignore
    }
}
export function saveGeniusSchoolDetailsSession(session) {
    writeSession(session);
}
export function saveGeniusLsqAccessToken(accessToken) {
    const trimmed = accessToken.trim();
    if (!trimmed)
        return;
    writeSession({
        ...(readSessionRaw() ?? {}),
        accessToken: trimmed,
    });
}
export function readGeniusLsqAccessToken() {
    return readSessionRaw()?.accessToken?.trim() || null;
}
export function readGeniusSchoolDetailsSession() {
    return readSessionRaw();
}
export function clearGeniusSchoolDetailsSession() {
    try {
        resolveStorage().removeItem(GENIUS_SCHOOL_DETAILS_SESSION_KEY);
    }
    catch {
        // ignore
    }
    memoryFallback = null;
}
